













































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import QRCode from 'qrcode';
import NavBar from '@/components/NavBar.vue';
import Logo from '@/components/Logo.vue';
import IconChaperone from '@/assets/icons/chaperone.svg';

import moment from 'moment';
import { Action, Getter } from 'vuex-class';
import TranslationSource from '@/types/i18n/TranslationSource';
import { Carousel, Slide } from 'vue-carousel';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import TaxcardSummary from '@/views/taxcard/transaction-detail/TaxcardSummary.vue';
import TransactionDetailPage from '@/views/taxcard/transaction-detail/TransactionDetailPage.vue';
import CommuneApi from '@/app/api/CommuneApi';
import { downloadCodeUrl, formatDownloadCode } from '@/app/utils/formatDownloadCode';

@Component({
  components: {
    TransactionDetailPage,
    TaxcardSummary,
    NewTranslation,
    NavBar,
    Logo,
    IconChaperone,
    Carousel,
    Slide,
  },
})
export default class TransactionDetailView extends Vue {
  public get pageData() {
    if (this.$route.query.pageData) {
      return JSON.parse(this.$route.query.pageData.toString());
    }
  }

  @Getter
  public communeInfo!: () => Promise<any>;

  @Getter
  public communeSelected!: any;

  public datetime: string[] = [];

  public interval: number = 0;

  public acceptingCommune: string = '';

  public qrCodes: string[] = [];

  public async created() {
    if (this.isCityTourTransaction) {
      return;
    }
    const qrCodeOptions = { margin: 0, color: { dark: '#FFFFFFFF', light: '#FFFFFF00' } };
    this.qrCodes.push(
      await QRCode.toDataURL(`https://web.welcmpass.info/qr/control?taxId=${this.pageData.taxId}`, qrCodeOptions)
    );
    this.displayableTaxcards.forEach((t: any) => {
      QRCode.toDataURL(`https://web.welcmpass.info/qr/control?taxId=${t.taxId}`, qrCodeOptions).then((url: string) =>
        this.qrCodes.push(url)
      );
    });
  }

  mounted() {
    this.time();
    this.interval = setInterval(this.time, 1000);
    if (this.belongsToSelectedCommune) {
      return;
    }
    const communes = this.$store.state.communes;
    const acceptingCommune = communes.find((c: any) => c.id === parseInt(this.$route.params.communeId, 10));
    this.acceptingCommune = (acceptingCommune && acceptingCommune.name) || '';
  }

  public get belongsToSelectedCommune() {
    return this.pageData.communeId === this.communeSelected;
  }

  public get duration() {
    return this.pageData.from === this.pageData.to
      ? moment(this.pageData.from).format('DD.MM.YYYY')
      : moment(this.pageData.from).format('DD.MM.YYYY') + ' - ' + moment(this.pageData.to).format('DD.MM.YYYY');
  }

  time() {
    this.datetime = [moment().format('DD.MM.YYYY'), moment().format('HH:mm:ss')];
  }

  public formatDate(date: string): string {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(i18next.t('common.date.format.short')) : 'Ungültiges Datum';
  }

  public get displayableTaxcards(): any[] {
    if (this.isCityTourTransaction) {
      return [];
    }
    return this.pageData.taxcards.filter((t: any) => t.status !== 'PRINTED' && !t.digitalOutputBlocked);
  }

  public get isCityTourTransaction(): boolean {
    return Boolean(this.pageData && this.pageData.taxcards && this.pageData.taxcards.every((t: any) => t.subGuestType === 'cityTour'));
  }

  public get cityTourCode() {
    const firstTaxcard = this.pageData.taxcards && this.pageData.taxcards[0];
    return (firstTaxcard && firstTaxcard.downloadCode) || '';
  }

  public get cityTourCodeDisplay(): string {
    return formatDownloadCode(this.cityTourCode);
  }

  public get cityTourCodeHref(): string {
    return downloadCodeUrl(this.cityTourCode);
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  public moment(...args: any[]): any {
    return moment(...args);
  }
}
